export default "__VITE_ASSET__DHg$GVoZ__"